import React, { useCallback, useEffect, useState } from "react";
// componentes
import {
  Table,
  Card,
  CardBody,
  CardTitle,
  Button,
  Collapse,
  Row,
} from "reactstrap";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import ModalNewCertificate from "./ModalNewCertificate";
import ModalEditCertificate from "./ModalEditCertificate";
import Pagination from "../../../components/Paginationv3";
import SearchFilters from "../../../components/SearchFilters";
import DeleteButton from "../../../components/Buttons/DeleteButton";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// redux
import { useSelector } from "react-redux";
// rotas
import { useLocation } from "react-router-dom";
// services
import {
  deleteCertificate,
  getAllCertificate,
} from "../../../utils/services/certificate";
import { deleteFile } from "../../../utils/services/files";
import { urlDomain } from "../../../utils/services/config";
// utils
import useDebounce from "../../../utils/hooks/useDebounce";

const columnsFilter = [
  { name: "Nome", value: "name", type: "text" },
  { name: "Tag", value: "tag", type: "text" },
  { name: "Data de Criação", value: "createdat", type: "date" },
  { name: "Últ. Atualização", value: "updatedat", type: "date" },
];

function getCertificateUrl(certificateId) {
  return `https://certificado.${urlDomain}/?idEvent={EVENTOID}&idPart={PAXID}&idCertificate=${certificateId}&namePart={PAXNOME}`;
}

export default function Certificate(props) {
  const location = useLocation();

  const { token: jwt } = useSelector((state) => state.global_user_data.data);
  //search and paginations
  const [search, setSearch] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  // collapse
  const [isOpen, setIsOpen] = useState(false);
  //new certificate
  const [modalNewCertificate, setModalNewCertificate] = useState(false);
  //edit certificate
  const [modalEditCertificate, setModalEditCertificate] = useState(false);
  //deletar evento
  const [confirmAlert, setConfirmAlert] = useState(false);
  const [successDlg, setSuccessDlg] = useState(false);
  const [deleteErrorDlg, setDeleteErrorDlg] = useState(false);

  const [certificates, setCertificates] = useState([]);
  const [selectedCertificate, setSelectedCertificate] = useState({});

  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("name");
  // loading
  const [loading, setLoading] = useState(false);

  const debouncedSearch = useDebounce(search, 300);

  // atualiza o filtro ativo e limpa a busca
  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  // inverte a data de dd/mm/yyyy para o formato aceito pela API (yyyy-mm-dd)
  const reverseDate = () => {
    const reverse = debouncedSearch
      .split("/")
      .reverse()
      .join("/")
      .replace(/\//g, "-");
    return reverse;
  };

  // aplica o tratamento de busca conforme o tipo da coluna filtrada (data ou texto)
  function treatmentSearch() {
    if (
      columnsFilter.filter((item) => item.value === activeFilter)[0].type ===
      "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }

  // copia o link do certificado para a área de transferência
  async function clipBoard(url) {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("O link foi copiado para a área de transferência");
    } catch (error) {
      console.error("Erro ao copiar o link:", error);
      toast.error("Erro ao copiar o link.");
    }
  }

  // abre/fecha o modal de criar certificado
  function toggleNewCertificate() {
    setModalNewCertificate(!modalNewCertificate);
  }

  // abre/fecha o modal de editar certificado
  function toggleEditCertificate() {
    setModalEditCertificate(!modalEditCertificate);
  }

  const formatDate = (date) => {
    try {
      const formatedDate = date.split("T")[0].split("-").reverse().join("/");
      const formatTime = date.split("T")[1].split(".")[0];

      return `${formatedDate} ${formatTime}`;
    } catch (error) {
      return date;
    }
  };

  // busca os certificados paginados
  const getCertificates = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getAllCertificate({
        jwt,
        eventId: location.state.idEvent,
        offset: currentPage,
        limit: itemsPerPage,
        search: treatmentSearch(),
        columnSearch: activeFilter,
      });

      setCertificates(response.data?.data?.certificates || []);
      setTotalItems(response.data?.data?.total);
    } catch (error) {
      console.error("Erro ao buscar certificados:", error);
      toast.error("Erro ao buscar certificados.");
    } finally {
      setLoading(false);
    }
  }, [
    jwt,
    location.state.idEvent,
    currentPage,
    itemsPerPage,
    debouncedSearch,
    activeFilter,
  ]);

  // exclui o certificado selecionado e o arquivo de imagem associado
  const excludeCertificate = useCallback(async () => {
    try {
      await deleteCertificate({ id: selectedCertificate.id, jwt });
      await deleteFile(selectedCertificate.imageId, jwt);

      setSuccessDlg(true);
      getCertificates();
    } catch (error) {
      console.error("Erro ao excluir certificado:", error);
      setDeleteErrorDlg(true);
    }
  }, [jwt, selectedCertificate, getCertificates]);

  useEffect(() => {
    getCertificates();
  }, [getCertificates]);

  return (
    <div>
      {modalNewCertificate && (
        <ModalNewCertificate
          isOpen={modalNewCertificate}
          toggle={toggleNewCertificate}
          eventId={location.state.idEvent}
          refetch={getCertificates}
        />
      )}
      {modalEditCertificate && (
        <ModalEditCertificate
          isOpen={modalEditCertificate}
          toggle={toggleEditCertificate}
          eventId={location.state.idEvent}
          refetch={getCertificates}
          certificate={selectedCertificate}
        />
      )}
      {confirmAlert ? (
        <SweetAlert
          title="Deseja deletar esse certificado?"
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            excludeCertificate();
            setConfirmAlert(false);
          }}
          onCancel={() => setConfirmAlert(false)}
        >
          Você não poderá reverter essa ação!
        </SweetAlert>
      ) : null}

      {successDlg ? (
        <SweetAlert
          success
          title="Sucesso"
          onConfirm={() => {
            setSuccessDlg(false);
          }}
        >
          Certificado deletado com sucesso
        </SweetAlert>
      ) : null}

      {deleteErrorDlg ? (
        <SweetAlert
          danger
          title="Erro"
          onConfirm={() => setDeleteErrorDlg(false)}
        >
          Erro ao excluir certificado.
        </SweetAlert>
      ) : null}
      <Card>
        <CardBody>
          <CardTitle>Certificado</CardTitle>
          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  value={search}
                  type={
                    activeFilter === "createdat" || activeFilter === "updatedat"
                      ? "date"
                      : "text"
                  }
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type={
                        activeFilter === "createdat" ||
                        activeFilter === "updatedat"
                          ? "date"
                          : "text"
                      }
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                <ActionButtonRounded
                  title="Criar Certificado"
                  onClick={() => setModalNewCertificate(true)}
                  type="mobile"
                />
              </Collapse>
            </div>

            <div className="header-btns-container">
              <ActionButtonRounded
                title="Criar Certificado"
                onClick={() => setModalNewCertificate(true)}
              />
            </div>
          </div>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>Nome do Certificado</th>
                  <th>TAG</th>
                  <th>Data de Criação</th>
                  <th>Data da Última Atualização</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <LoadingSkelentonTable lines={10} cols={5} />
                ) : (
                  certificates.length > 0 &&
                  certificates.map((e) => {
                    const certificateUrl = getCertificateUrl(e.id);

                    return (
                      <tr key={e.id}>
                        <td>{e.name}</td>
                        <td>
                          {e.tags.map((tag) => (
                            <span key={tag.name} className="tagDriver">
                              {tag.name + " "}
                            </span>
                          ))}
                        </td>
                        <td>{formatDate(e.createdAt)}</td>
                        <td>{formatDate(e.updatedAt)}</td>
                        <td>
                          <i
                            className="mdi mdi-content-copy"
                            style={{
                              color: "grey",
                              fontSize: 17,
                              margin: "0 3px",
                              cursor: "pointer",
                            }}
                            title="Copiar"
                            onClick={() => clipBoard(certificateUrl)}
                          />
                          <a
                            href={certificateUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Visualizar Certificado"
                          >
                            <i
                              className="mdi mdi-eye"
                              style={{
                                color: "blue",
                                fontSize: 17,
                                margin: "0 3px",
                                cursor: "pointer",
                              }}
                            />
                          </a>
                          <i
                            className="mdi mdi-pencil"
                            title="Editar"
                            style={{
                              margin: "0 3px",
                              color: "green",
                              fontSize: 17,
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setSelectedCertificate(e);
                              setModalEditCertificate(true);
                            }}
                          />
                          <DeleteButton
                            onClick={() => {
                              setSelectedCertificate(e);
                              setConfirmAlert(true);
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      <div className="bottom-navigation" style={{ justifyContent: "end" }}>
        {/*
        Fornecer os 4 parametros obrigatórios;
        ** data - a array contendo as informações da tabela
        ** search - o state do termo de pesquisa
        ** currentIndex - posição atual do index
        ** setCurrentIndex - função para atualizar a posição atual do index
        */}
        <Pagination
          data={certificates}
          search={search}
          currentIndex={currentPage}
          setCurrentIndex={setCurrentPage}
          countData={totalItems}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </div>
  );
}
